module.exports = __webpack_public_path__ + "static/media/ic_documents.3a0ca7b3.svg";